import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { ISocialHonor } from '@src/types/resumeDetail/socialType';
import { ICampusHonor } from '@/src/types/resumeDetail/campusType';
import './index.scss';

interface IProps {
  data: ISocialHonor[] | ICampusHonor[];
  type: string;
  setMode: Function;
}

// 社校共用
const HonorView: FC<IProps> = (props) => {
  const { data, type, setMode } = props;

  const { campusResumeFormRefStore, socialResumeFormRefStore } = useRootStore();
  let storeRef;
  if (type === 'campus') {
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    storeRef = socialResumeFormRefStore;
  }

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('honor_edit');
  };
  return (
    <div className="honor_view model_view">
      <div className="model_title">
        <div>荣誉</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      {data?.map((item) => (
        <div className="model_list" key={item.renderId}>
          <div className="model_top">
            <div className="project_honor_name">
              <span>{item.honorName}</span>
            </div>
          </div>
          <div className="model_line" />
          <div className="model_bottom">
            <div className="label">
              <div className="label_left">荣誉描述：</div>
              <div className="label_right">{item.honorDesc || '-'}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HonorView;
